import {faD} from "@fortawesome/free-solid-svg-icons";

export default faD;
